import { create } from 'zustand';
import { Module, moduleService } from '../services/moduleService';

interface ModuleState {
  modules: Module[];
  loaded: boolean;
  loading: boolean;
  fetch: (force?: boolean) => Promise<void>;
  isModuleVisible: (slug: string) => boolean;
  getModuleStatus: (slug: string) => Module['status'] | null;
}

let inflight: Promise<void> | null = null;

export const useModuleStore = create<ModuleState>((set, get) => ({
  modules: [],
  loaded: false,
  loading: false,
  fetch: async (force = false) => {
    if (!force && get().loaded) return;
    if (inflight) return inflight;

    set({ loading: true });
    inflight = (async () => {
      try {
        const data = await moduleService.getActiveModules();
        if (Array.isArray(data) && data.length > 0) {
          set({ modules: data });
        }
      } catch {
        // Keep previous modules on error; mark loaded to avoid retry storms.
      } finally {
        set({ loaded: true, loading: false });
        inflight = null;
      }
    })();
    return inflight;
  },
  isModuleVisible: (slug) => {
    const { modules, loaded } = get();
    if (!loaded || modules.length === 0) return true;
    return modules.some((m) => m.slug === slug);
  },
  getModuleStatus: (slug) => {
    const mod = get().modules.find((m) => m.slug === slug);
    return mod?.status ?? null;
  },
}));
